const ACFBlockReadMore = (blockElem) => {

	// Setup the read moe button that will reveal the adjacent wp-block-group
	const readMoreButton = blockElem.querySelector('.read-more-button');
	readMoreButton.addEventListener('click', (e) => {
		e.preventDefault();
		blockElem.classList.add('js-reveal-content');
	});

	// Get the adjacent wp-block-group and append a close button to it
	const adjacentGroup = blockElem.nextElementSibling;

	const closeButton = readMoreButton.cloneNode(true);
	closeButton.classList.add('js-close-button');
	closeButton.addEventListener('click', (e) => {
		e.preventDefault();
		blockElem.classList.remove('js-reveal-content');
	})

	adjacentGroup.appendChild(closeButton);
};

export default ACFBlockReadMore;